"use strict";

freeLunchReport.service("FreeLunchReportService", function($http, authServiceFactory, $cookieStore, ipCookie)
{
    this.loading = false;
    this.dataLoaded = false;
    this.results = [];
    this.createReport = function(year)
    {
        var parent = this;
        this.loading = true;
        $http.get("/api/school/" + authServiceFactory.getAuth().schoolID + "/FreeLunchReport/" + year)
        .then(function(response) {
            parent.loading = false;
            parent.results = response.data;
            parent.dataLoaded = true;
        }, function() {
            parent.loading = false;
            parent.results = [];
            parent.dataLoaded = true;
        });
    };
    this.setSort = function(field, reverse)
    {
        var temp = $cookieStore.get('sort');
        temp.field = field;
        temp.reverse = reverse;
        ipCookie('sort', temp);
    };

    this.getSort = function()
    {
        if (typeof $cookieStore.get('sort') === "undefined")
        {
            this.initSort();
        }
        return $cookieStore.get('sort');
    };
    this.initSort = function()
    {
        sort.field =  "name";
        sort.reverse = false;
        ipCookie('sort', sort);

    };
    this.iconClass = function(header)
    {
        var sort = this.getSort();
        if (this.activeClass(header) == 'active')
        {
            if (sort.reverse)
                return 'ion-ios7-arrow-down';
            else
                return 'ion-ios7-arrow-up';
        }
        return '';
    };
    this.activeClass = function(header)
    {
        var sort = this.getSort();
        if (sort.field == header)
            return 'active'
        return ''
    };
    return this;

});
